import React from 'react';
import { useTranslation } from 'react-i18next';
import { TextField } from '@mui/material';

const DsmDiscussionStep = ({ form, errors, update }) => {
  const { t } = useTranslation();

  return (
    <TextField
      required
      multiline
      minRows={5}
      label={t('showroomProjectRequest.dsmDetails')}
      value={form.dsmDiscussionDetails}
      onChange={event => update('dsmDiscussionDetails', event.target.value)}
      error={errors.dsmDiscussionDetails}
      helperText={errors.dsmDiscussionDetails && t('showroomProjectRequest.required')}
      fullWidth
    />
  );
};

export default DsmDiscussionStep;
